import { takeLatest, put, call } from 'redux-saga/effects';

import { listPragaDoenca } from '../service';

import {
  TABLE_PRAGA_DOENCA,
  TABLE_PRAGA_DOENCA_PENDING,
  TABLE_PRAGA_DOENCA_SUCCESS,
  TABLE_PRAGA_DOENCA_FAILURE
} from '../actionTypes';

function* sagaListPragaDoenca(action) {
  yield put({ type: TABLE_PRAGA_DOENCA_PENDING })

  try {
    const table = yield call(listPragaDoenca, action.args)
    yield put({ type: TABLE_PRAGA_DOENCA_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_PRAGA_DOENCA_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListPragaDoenca() {
  yield takeLatest(TABLE_PRAGA_DOENCA, sagaListPragaDoenca)
}